import { render, staticRenderFns } from "./disReceiverList.vue?vue&type=template&id=225837eb&scoped=true"
import script from "./disReceiverList.vue?vue&type=script&lang=js"
export * from "./disReceiverList.vue?vue&type=script&lang=js"
import style0 from "./disReceiverList.vue?vue&type=style&index=0&id=225837eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225837eb",
  null
  
)

export default component.exports